<template>
  <el-dialog :visible="show" @close="closeModal" width="80%">
    <ModalHeader slot="title" title="Thông tin tài liệu" icon="fa fa-info-circle" />
    <el-row>
      <el-col :span="12" class="document-info">
        <el-row :gutter="20" class="info-row">
          <el-col :span="6">
            <span class="title-info">Tài liệu</span>
          </el-col>
          <el-col :span="18">
            <span class="infomation">{{ document.name }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="info-row" v-if="document.author">
          <el-col :span="6">
            <span class="title-info">Tác giả</span>
          </el-col>
          <el-col :span="18">
            <span class="infomation">{{ document.author }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="info-row" v-if="document.userEmail">
          <el-col :span="6"> Email </el-col>
          <el-col :span="18" class="infomation">
            {{ document.userEmail }}
          </el-col>
        </el-row>
        <el-row :gutter="20" class="info-row">
          <el-col :span="6">
            <span class="title-info">Độ trùng lặp</span>
          </el-col>
          <el-col :span="18"> {{ document.score }} % </el-col>
        </el-row>
        <el-row :gutter="20" class="info-row">
          <el-col :span="6"><span class="title-info" v-if="document.spellError">Lỗi chính tả</span></el-col>
          <el-col :span="18">
            {{ document.spellError }}
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <ve-pie :data="chartData" :legend-visible="false"/>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeModal">Đóng</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { apiGetDocummentSummaryResult } from "@/services/document_management_service"
import FAIcon from "@/components/common/FAIcon.vue"
import ModalHeader from "@/components/common/ModalHeader.vue"
import VePie from "v-charts/lib/pie.common"

export default {
  name: "DocumentInfoModal",
  components: { ModalHeader, FAIcon, VePie},
  data() {
    return {
      show: false,
      chartData: {
        columns: ['label', 'percent'],
        rows: []
      },
      document: {},
    }
  },
  methods: {
    async showModal(document) {
      this.document = document
      const documentInfo = await apiGetDocummentSummaryResult(this.document.slug)
      if (!documentInfo) {
        this.$message.error("Có lỗi xảy ra")
        return
      }
      const abnormalPercent = documentInfo.abnormalPercent || 0
      const ignoredByUserPercent = documentInfo.ignoredByUserPercent
      const noSimilarityPercent = 100 - ignoredByUserPercent - documentInfo.score - abnormalPercent
      this.chartData.rows = [
        {label: "Phần trăm không trùng lặp", percent: noSimilarityPercent},
        {label: "Phần trăm trùng lặp", percent: documentInfo.score},
        {label: "Phần trăm người dùng bỏ qua", percent: documentInfo.score},
        {label: "Phần trăm hệ thống bỏ qua", percent: documentInfo.score}
      ]
      this.show = true
    },
    closeModal() {
      this.show = false
    },
  },
}
</script>

<style scoped>

.title-info {
  font-size: 0.9rem;
}

.infomation {
  font-size: 0.9rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-row {
  width: 100%;
  margin: 10px 0;
  word-wrap: break-word;
}

.document-info {
  heigh: 100%;
  display: flex;
  flex-direction: column;
  align-item: center;
  justify-content: center;
  padding: 20px;
}

.info-chart {
  display: flex;
  align-items: flex-end;
}

.disabled-icon {
  color: gray;
  opacity: 0.5;
  cursor: default !important;
}
</style>
